import { DialogProps, PopperPlacementType } from "@mui/material";

import { UUID } from "crypto";

import { Deed } from "./dictamen";
import { BpmUser } from "./users";
import { Reference } from "./references";
import { GuaranteeType } from "./catalogs";
import { AccountInfo, DocumentInfo } from "./documents";
import { ApplicationMarketplaceResume, ApplicationResume, Guarantee } from "./application";
import { GridFilterModel, GridPaginationModel, GridSortModel } from "@mui/x-data-grid";

export enum DialogType {
    NONE,
    RECHAZAR_DOC,
    VALIDAR_DOC,
    VALIDAR_EXP,
    VALIDAR_DIC,
    BORRAR_DOC,
    REGENERAR_DOC,
    // CONFIRMAR_ACCION,

    AGENDAR_VISITA,
    DOCS_FALTANTES,
    // ESTATUS_NOTIFICACION,
    DESCARGAR_REPORTE,
    DESCARGAR_REPORTE_PLD,

    // REVISION_AUTORIZAR,
    // REVISION_RECHAZAR,
    // REVISION_RECHAZAR_BLOQUEAR,
    COMENTARIOS,
    CODIGOS_ATRIBUCION,
    NUEVO_ACCIONISTA_MAYORITARIO,
    OBSERVACION_REVISION_EXTERNA,
    ERRORES_ALTA_CARTERA,
    EDICION_INFO_BANCARIA,
    OFERTAR,

    EDICION_ESTATUS,
    VISTA_COMPANIA,
    EDICION_REFERENCIA,

    ALTA_EDICION_USUARIO,
    // ALTA_EDICION_FINANCIERAS,
    ALTA_EDICION_REGLAS_MODELO,
    ALTA_EDICION_REGLAS_MODELO_FINANCIERA,

    EDICION_TIPO_GARANTIA,
    // EDICION_GARANTIA_VEHICULAR,
    EDICION_GARANTIA_INMOBILIARIA,

    CUENTA_ADICIONAL,
    REVISION_CHECKPOINT,
}

export enum PopupType {
    NONE,
    DETALLE_ABORTIVO,
    COMENTARIOS,
    EDICION_SOLICITUD_CREDITO,
    EDICION_AVALES,
    EDICION_PROP_REAL,
    EDICION_CONYUGE,
    DETALLE_CONTRACTUALES,
    COMENTARIOS_MOTIVO_RECHAZO_CONTRACTUALES,
    EDICION_ESCRITURA,
}

export enum ButtonType {
    VALIDAR_AUTORIZACION,
    RECHAZAR,
    RECHAZAR_BLOQUEAR,
    VALIDAR_DICTAMEN,
    DOCS_FALTANTES,
    VALIDAR_EXPEDIENTE,
    VALIDAR_VISITA,
    DESCARGAR_EXPEDIENTE,
    VOLVER_VISITAR,
    LIBERAR_DISPERSION,
    CONVERTIR_CLIENTE,
    COMENTARIOS,
    VALIDAR_CONTRON,
    REGRESAR_AREA,
    VALIDAR_GENERICO,
    VALIDACION_CONTROL,
    GUARDAR,
    GENERAR_CONTRACTUALES,
    VALIDAR_FIRMA_CLIENTE,
}

export enum OptionApplicationMenu {
    INFO_GRAL,
    PERFIL_CREDITICIO,
    RPC_PLD,
    DICTAMEN_LEGAL,
    // PERFIL,
    // DICTAMEN,
    EXPEDIENTE,
    VALIDACION_CREDITICA,
    LEGAL_PLD,
    VISITA_OCULAR,
    REVISION_CONTROL,
    CONTRACTUALES,
    DISPERSION,
    RESUMEN_OPERACION,

    USUARIOS,
    ROLES_PERMISOS,
    MODULOS,
    CODIGOS_ATRIBUCION,
    REGLAS_ADMISION,
    LOG_ACTIVIDAD,
}

export enum DocumentAction {
    SEE,
    DOWNLOAD,
    UPLOAD,
    DELETE,
    VALIDATE,
    VALIDATE_TO_SIGN,
    REJECT,
    REJECT_RELOAD,
    VALIDATE_SIGN,
    REJECT_SIGN,
    SEND_MIFIEL,
    CLIENT_SIGN,
    INTERNAL_SIGN,
    LEGAL_INCIDENT_SELECTED,
    LEGAL_INCIDENT_SUBTYPE_SELECTED,
    REGENERATE,
    EXT_VALIDATE,
    SIGNED,
    VALIDATE_DISPERSION,
    SEE_SIGNED,
    DOWNLOAD_SIGNED,
    STATUS,
    NONE,
}

export interface ApplicationSelected extends ApplicationResume {
    dictamenCompletado: boolean;
    company_docs_validated: boolean;
    shareholder_docs_validated: boolean;
    owners_docs_validated: boolean;
    existsSDC: boolean;
    credit_validated: boolean | null;
    pld_validated: boolean | null;
    legal_incidents_validated: boolean | null;
    visit_analysis_validated: boolean | null;
    check_control_validated: boolean | null;
}

export interface ApplicationMarketplaceSelected extends ApplicationMarketplaceResume {
    dictamenCompletado: boolean;
    company_docs_validated: boolean;
    shareholder_docs_validated: boolean;
    owners_docs_validated: boolean;
    existsSDC: boolean;
    credit_validated: boolean | null;
    pld_validated: boolean | null;
    legal_incidents_validated: boolean | null;
    visit_analysis_validated: boolean | null;
    check_control_validated: boolean | null;
}

export interface RejectDialogProps {
    document: DocumentInfo;
}

export interface ValidateDialogProps {
    title: string;
}

export interface StatusNotificationDialogProps extends ValidateDialogProps {
    iconType: "success" | "error" | "warning" | "info" | "none";
    showApplicationInfo: boolean;
}

export interface RevisionCheckPointDialogProps {
    checkPointType: string;
    title: string;
    onAcceptClick: () => void;
}

export interface AdditionalAccountDialogProps {
    personTypeCode: string;
    onAcceptClick: () => void;
}

export interface GuaranteeTypeEditionDialogProps {
    type: "EDIT" | "ADD";
    guaranteeType: GuaranteeType;
    onAcceptClick: () => void;
}

export interface RuleModelEditionDialogProps {
    type: "EDIT" | "ADD";
    taxSystemId: UUID;
    onAcceptClick: () => void;
}

export interface FinancialRuleModelEditionDialogProps {
    type: "EDIT" | "ADD";
    taxSystemId: UUID;
    financialCoId: UUID;
    onAcceptClick: () => void;
}

// export interface FinancialEditionDialogProps {
//     type: "EDIT" | "ADD";
//     financial: FinancialCompany;
//     onAcceptClick: () => void;
// }

export interface UserEditionDialogProps {
    type: "EDIT" | "ADD";
    user: BpmUser;
    onAcceptClick: () => void;
}

export interface GuaranteeEditionDialogProps {
    type: string;
    guarantee: Guarantee;
    onAcceptClick: () => void;
}

export interface ReferenceEditionDialogProps {
    type: "EDIT" | "ADD";
    reference: Reference;
    onAcceptClick: () => void;
}

export interface CommentsDialogProps {
    title: string;
    subtitle: string;
    moduleCode: string;
    metadata?: any;
}

export interface ValidateVisitDialogProps {
    title: string;
    date: string;
    time: string;
}

export interface AttribCodeDialogProps {
    register: boolean;
    bulkUpload?: boolean;
    data?: {
        businessName: string;
        attributionCode: string;
        source: string;
        medium: string;
        region: string;
        partnership: string;
        email: string;
        phone: string;
    };
}

export interface EditionBankingInformationDialogProps {
    type: "COMPANY" | "PERSON";
    account?: AccountInfo;
    personId?: UUID;
    onAcceptClick: () => void;
}

export interface OfferActionDialogProps {
    type: "OFFER" | "REJECT";
    updated: boolean;
    onAcceptClick: (action: "OFFER" | "REJECT") => void;
}

export interface NewMajorityShareholder {}

export interface ExternalReviewComments {
    type: "REJECT_DOCUMENT" | "RETURN_WITH_COMMENTS";
    docId?: UUID;
    docType?: string;
    onConfirmClick: () => void;
    onBackClick: () => void;
}

export interface RevisionDialogProps {
    // type: "Authorize" | "Block" | "Reject";
    module: string;
}

export interface RegistrationInPortfolioErrors {
    errors: Array<any>;
    data: any;
}

export interface DialogConfig {
    shown: boolean;
    fullscreen?: boolean;
    fullWidth?: boolean;
    maxWidth?: DialogProps["maxWidth"];
    type: DialogType;
    props:
        | undefined
        | RejectDialogProps
        | ValidateDialogProps
        | ValidateVisitDialogProps
        | StatusNotificationDialogProps
        | CommentsDialogProps
        | AttribCodeDialogProps
        | NewMajorityShareholder
        | ExternalReviewComments
        | EditionBankingInformationDialogProps
        | OfferActionDialogProps
        | UserEditionDialogProps;
    isProcessing?: boolean;
    onRejectClick?: () => void;
    onAcceptClick?: () => void;
    onCloseClick?: () => void;
}

export interface PopupProps {
    config: {
        placement?: PopperPlacementType;
    };
}

export interface AbortivePopupProps {
    details: any;
}

export interface GeneralCommentsProps {
    width: any;
}

export interface EditionCreditAppProps {
    // width: any;
    personId: UUID;
    onSaved: () => void;
}

export interface EditionEndorsementProps {
    width: any;
    endorsementId: UUID;
}

export interface EditionActualOwnerProps {
    width: any;
    endorsementId: UUID;
}

export interface ReasonRejectionComment {
    text: any;
}

export interface EditionDeedProps {
    width: any;
    deed: Deed;
    readonly: boolean;
}

export interface PopupConfig {
    type: PopupType;
    props:
        | undefined
        | AbortivePopupProps
        | GeneralCommentsProps
        | EditionCreditAppProps
        | EditionEndorsementProps
        | EditionActualOwnerProps
        | ReasonRejectionComment
        | EditionDeedProps;
    // anchorEl: HTMLElement | null | undefined;
    anchorEl: string | null | undefined;
    placement: PopperPlacementType;
    width?: any;
    maxWidth?: any;
}

export interface Shareholder {
    id: UUID;
    name: string;
    lastName: string;
    lastName2: string;
    rfc: string;
    totalValue: number;
    percent: number;
    legalAgent: boolean;
    majorityShareholder: boolean;
    actualOwner: boolean;
    guarantee: boolean;
    toAdd: boolean;
    toDelete: boolean;
    toUpdate: boolean;
    isNew: boolean;
    // personTypeCode: string;
    is_aval_onboarding: boolean;
    is_first_majority_shareholder: boolean;
    fixedCapitalShares: number;
    variableCapitalShares: number;
    extra_types: Array<UUID>;
}

export enum DocumentGenerationStatus {
    CREATED,
    PROCESSING,
    ERROR,
    NOT_FOUND,
}

export interface ConfigList {
    code: string;
    filters: GridFilterModel;
    sort: GridSortModel;
    pagination: GridPaginationModel;
    rowCount: number;
}
